<template>
  <v-container>
    <ReceiptViewer
      ref="receiptDetails"
      inspectMode
      v-on:hide="showDialog = false"
      :showDialog="showDialog"
      :receiptImage="receiptImageElement"
      :receiptImageIsLoading="receiptImageIsLoading"
      :editMode="false"
    />
    <v-card v-if="selectedDashboard.hasRejectedReceipt">
      <v-layout column>
        <v-flex style>
          <v-row class="optionsBox">
            <v-col class="dropdown" v-if="getCampaignId">
              <v-autocomplete
                v-model="selectedCampaignId"
                :items="selectableCampaigns"
                item-text="text"
                item-value="symbol"
                label="Select Campaign Id"
                @change="getRejectionReason"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="dropdown">
              <v-autocomplete
                v-model="rejectReason"
                :items="rejectReasons"
                item-text="key"
                item-value="symbol"
                label="Select Rejection Type"
                @change="setSelectedRejection"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="searchBox">
              <v-row>
                <v-btn
                  class="button"
                  color="blue darken-2"
                  :disabled="isPending"
                  @click="getRejectedReceipts(true)"
                  >Search
                </v-btn>
              </v-row>
            </v-col>
          </v-row>

          <v-data-table
            v-if="searchClick"
            :items="rejectedReceipts"
            :no-data-text="'Receipts no DataText'"
            :disable-pagination="true"
            :hide-default-footer="true"
            :headers="headers"
          >
            <template slot="item" slot-scope="{ item }">
              <tr @click="setCurrentReceipt(item, item.campaign)">
                <td>{{ item.referenceNumber }}</td>
                <td>{{ formattedDate(item.createdAt) }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.processedBy }}</td>
                <td>{{ item.rejectReason }}</td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert
                v-if="searchClick"
                :value="true"
                icon="mdi-cancel"
                class="display-1 font-weight-thin"
                >No receipts found for now ¯\_(ツ)_/¯</v-alert
              >
            </template>
            <template slot="footer">
              <v-btn
                v-if="showLoadMore"
                class="buttonFooter"
                color="teal darken-1"
                :disabled="isPending"
                @click="getRejectedReceipts(false)"
                >Load More
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card v-else>
      <v-layout column>
        <v-flex style>
          <v-alert
            :value="true"
            icon="mdi-cancel"
            class="display-1 font-weight-thin"
            >Rejected Receipts has not yet been added for this campaign.
            ¯\_(ツ)_/¯</v-alert
          >
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import ReceiptViewer from "../components/ReceiptViewer";
import moment from "moment";
import axios from "axios";

export default {
  components: {
    ReceiptViewer
  },
  watch: {
    showDialog(val) {
      if (val === false) {
        this.receiptImageElement = null;
        this.receiptImageIsLoading = true;
        this.img = new Image();
      }
    },
    searchReceiptId() {
      this.searchForReceipt(this.infiniteState);
    },
    searchCampaignId() {
      this.searchForReceipt(this.infiniteState);
    },
    searchDashboarderId() {
      this.searchForReceipt(this.infiniteState);
    }
  },
  data() {
    return {
      img: new Image(),
      receiptImageElement: new Image(),
      receiptImageIsLoading: true,
      isLoading: true,
      isPending: false,
      showLoadMore: false,
      selectableCampaigns: [],
      rejectedReceipts: [],
      selectedCampaignId: "",
      searchClick: false,
      count: 1,
      showDialog: false,
      page: 0,
      headers: [
        {
          sortable: false,
          align: "left",
          text: "Receipt ID",
          value: "receiptId"
        },
        {
          sortable: false,
          text: "Uploaded Time",
          value: "id"
        },
        {
          sortable: false,
          text: "Status",
          value: "campaignTitle"
        },
        {
          sortable: false,
          text: "Process Type",
          value: "campaignTitle"
        },
        {
          sortable: false,
          text: "Rejection",
          value: "campaignTitle"
        }
      ],
      recentReceipts: []
    };
  },
  computed: {
    ...mapGetters([
      "userToken",
      "selectedDashboard",
      "rejectReasons",
      "selectedRejectReason"
    ]),
    ...mapFields([
      "reClaimed",
      "reClaimText",
      "referenceNumber",
      "receiptImageURL",
      "createdAt",
      "createdAtDate",
      "createdAtTime",
      "status",
      "id",
      "campaignTitle",
      "campaign_fk",
      "receiptNumber",
      "total",
      "campaignRetailers",
      "hasWallet",
      "products",
      "couponsToCreate",
      "hasEditableCoupons",
      "productImageURL",
      "detailsText",
      "campaignEndDate",
      "campaignStartDate",
      "processedProducts",
      "productTotal",
      "retailerFk",
      "customerToken",
      "selectedProducts",
      "rejectReason",
      "total",
      "receiptId",
      "paymentAmount",
      "receiptDateTime",
      "prevReceipts",
      "prevParticipations",
      "processHistory",
      "used",
      "usedReceipts",
      "postCode",
      "clubCode",
      "fiscalId",
      "rppData"
    ]),
    getCampaignId: {
      get() {
        if (this.selectedDashboard.campaignId === "pg-template") {
          this.selectableCampaigns = [
            { text: "al-testwoche", value: "" },
            { text: "always-2.0-testwochen", value: "" },
            { text: "always-testwoche", value: "" },
            { text: "ariel-3.0-de", value: "" },
            { text: "ariel-4.0-rabatt", value: "" },
            { text: "hs-cashback", value: "" },
            { text: "lenor-at", value: "" },
            { text: "lenor-dm", value: "" },
            { text: "lenor-un", value: "" },
            { text: "lenor-wama", value: "" },
            { text: "pampers-2.0-spar", value: "" },
            { text: "pampers-3.0-aldi", value: "" },
            { text: "pampers-spar", value: "" },
            { text: "pampers-rossmann", value: "" },
            { text: "always-3.0-testwochen", value: "" },
            { text: "lenor-pm", value: "" },
            { text: "always-dm", value: "" },
            { text: "fairy-testen", value: "" },
            { text: "febreze-testen", value: "" },
            { text: "lenor-mini", value: "" },
            { text: "oldspice-mini", value: "" },
            { text: "oldspice-testwochen", value: "" },
            { text: "ariel-pledge", value: "" },
            { text: "bad-testen", value: "" },
            { text: "pg-professional", value: "" }
          ];
        } else if (this.selectedDashboard.campaignId === "pg-ro") {
          this.selectableCampaigns = [
            { text: "pg-youtil-ro", value: "" },
            { text: "pg-charity-ro", value: "" },
            { text: "pampers-auchan-ro", value: "" }
          ];
        } else if (this.selectedDashboard.campaignId === "pg-turkey") {
          this.selectableCampaigns = [
            { text: "firsat-yaninda", value: "" },
            { text: "firsat-yaninda-olimpiyat", value: "" }
          ];
        } else {
          this.selectableCampaigns = [];
        }
        return true;
      }
    }
  },
  methods: {
    ...mapActions([
      "searchReceipt",
      "getAnyReceiptWithId",
      "getDashboardData",
      "getProductsList",
      "getReceiptwithRefNumber",
      "getPrevParticipations",
      "errorHandler"
    ]),
    setCurrentReceipt(item) {
      this.$refs.inspectMode = false;
      this.getPrevParticipations({
        userToken: this.userToken,
        referenceNumber: item.referenceNumber,
        dashboard: this.selectedDashboard
      }).then(prevParticipations => {
        if (prevParticipations.receipts) {
          this.prevReceipts = prevParticipations.receipts;
          this.usedReceipts = prevParticipations.usedReceipt;
          this.customerInfo = prevParticipations.customerInfo;
        }
      });
      this.getReceiptwithRefNumber({
        userToken: this.userToken,
        referenceNumber: item.referenceNumber,
        dashboard: this.selectedDashboard
      }).then(res => {
        const receipt = res.receipt;

        const products = res.campaignProducts;
        if (this.selectedDashboard.isCroppable) {
          this.receiptImageURL = receipt.receiptFullImageURL;
        } else {
          this.receiptImageURL = receipt.receiptImageURL;
        }
        this.productImageURL = receipt.productImageURL;

        const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard,
          campaign_fk: receipt.campaign_fk
        };
        this.getDashboardData(payload);
        this.img = new Image();
        this.receiptImageIsLoading = true;
        this.img.onload = () => {
          this.paymentAmount = receipt.paymentAmount;
          this.receiptImageIsLoading = false;
          this.receiptImageElement = this.img;
        };

        this.img.src = this.receiptImageURL;
        this.createdAt = receipt.createdAt;
        this.campaignTitle = receipt.campaignTitle;
        this.campaign_fk = receipt.campaign_fk;
        this.receiptDateTime = receipt.receiptDateTime;
        this.createdAtTime = moment(receipt.updatedAt).format("HH:MM");
        this.createdAtDate = receipt.updatedAt;
        this.status = receipt.status;
        this.id = receipt.receiptToken;
        this.customerToken = receipt.customerToken;
        this.referenceNumber = receipt.referenceNumber;
        this.receiptNumber = receipt.identifiedId;
        this.total = receipt.total;
        this.postCode = receipt.postCode;
        this.receiptId = receipt.receiptId;
        this.couponsToCreate = receipt.couponsPerReceipt;
        this.detailsText = receipt.detailsText;
        this.retailerFk =
          receipt.retailer == "15" ? "Not selected" : receipt.retailer;
        if (typeof this.retailerFk === "string") {
          this.retailerFk = parseInt(this.retailerFk);
        }
        if (receipt.processHistory) {
          try {
            this.processHistory = JSON.parse(receipt.processHistory);
          } catch {
            this.processHistory = [];
          }
        }
        console.log("HIST: ", this.processHistory);
        this.campaign_fk = receipt.campaignId;
        this.rejectReason = receipt.rejectReason;
        this.used = receipt.rejectReason === "used" ? true : false;
        this.paymentAmount = receipt.paymentAmount;
        if (receipt.clubCode) this.clubCode = receipt.clubCode;
        if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
        if (receipt.rppData) this.rppData = receipt.rppData;
        this.campaignEndDate = moment(receipt.campaignEndDate).format(
          "DD-MM-YYYY"
        );
        this.campaignStartDate = moment(receipt.campaignStartDate).format(
          "DD-MM-YYYY"
        );
        this.hasWallet = receipt.hasWallet;
        if (receipt.selectedProducts) {
          this.selectedProducts = JSON.parse(receipt.selectedProducts);
          console.log("PPPP", this.selectedProducts);
        }
        if (this.hasWallet) {
          const identifications = JSON.parse(receipt.identifications);

          if (identifications) this.productTotal = identifications.productTotal;
        }

        this.getProductsList({
          dashboard: this.selectedDashboard,
          campaignId: receipt.campaignId
        }).then(products => {
          if (products.length) {
            this.products = products;
            this.processedProducts = [];
            this.showDialog = true;
          } else if (this.selectedDashboard.campaignId === 'pg-ro') {
            this.products = products
            this.processedProducts = []
            this.showDialog = true
          }
        });

        if (this.couponsToCreate === -1) {
          this.hasEditableCoupons = true;
          this.couponsToCreate = 1;
        }
        this.campaignRetailers = res.campaignRetailers;

        if (receipt.hasWallet) {
          this.hasWallet = receipt.hasWallet;
        }
        console.log("PPP", receipt.selectedProducts);
        if (res.campaignProducts.length) {
          this.products = res.campaignProducts;
          this.processedProducts = [];
          if (
            "processedProducts" in receipt &&
            receipt.processedProducts != null
          ) {
            const parsedSelecteds = JSON.parse(receipt.processedProducts);
            parsedSelecteds.forEach(selectedProduct => {
              const product = {
                groupingId: selectedProduct.groupingId.split("$$")[1],
                items: selectedProduct.items,
                total: selectedProduct.total
              };
              this.processedProducts.push(product);
              const foundProduct = this.products.find(
                e => e.ean === product.groupingId
              );
              foundProduct.count = product.items;
            });
          }
        }
      });
    },

    formattedDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    getRejectedReceipts(first) {
      this.isPending = true;
      if (first) {
        this.count = 1;
      } else {
        this.count += 1;
      }
      axios({
        method: "post",
        url: `${this.selectedDashboard.endPoints.base}${this.selectedDashboard.endPoints.getRejectedReceipts}`,
        data: {
          sessid: this.userToken,
          campaignId: this.selectedCampaignId,
          rejectReason: this.selectedRejectReason,
          count: this.count
        }
      })
        .then(response => {
          if (response.data.response) {
            this.rejectedReceipts = response.data.rejectReceipts;
            this.isPending = false;
            if (response.data.allData) {
              this.showLoadMore = false;
            } else {
              this.showLoadMore = true;
            }
          } else {
            this.isPending = false;
            this.errorHandler(response.data.message || response.data.error)
          }
        })
        .catch(er => {
          this.isPending = false;
          this.errorHandler(er.response)
        });
      this.searchClick = true;
    },
    getRejectionReason() {
      const payload = {
        userToken: this.userToken,
        dashboard: this.selectedDashboard,
        campaign_fk: this.selectedCampaignId
      };
      this.getDashboardData(payload);
      this.$store.commit("setRejectReasons", []);
      this.rejectedReceipts = [];
      this.$store.commit("setSelectedRejectReason", "");
      this.rejectReason = "";
      this.showLoadMore = false;
      this.searchClick = false;
      this.count = 1;
    },
    setSelectedRejection() {
      this.$store.commit("setSelectedRejectReason", this.rejectReason);
    }
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>

<style scoped>
.optionsBox {
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 12px;
}
.dropdown {
  max-width: 50%;
}
.searchBox {
  max-width: 30%;
  display: flex;
  align-items: center;
}
.buttonFooter {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
